<script setup>
import CmprRadio from '@cta/frontend/components/CmprRadio.vue';

const choice = defineModel('choice', { type: String });

const props = defineProps({
  choices: {
    type: Array,
    default() {
      return [];
    },
  },
  analyticsIdPrefix: {
    type: String,
    default: 'donate-call',
  },
});

function onlyChoiceSelected() {
  return props.choices.length === 1 && props.choices.at(0).paymentType === choice.value;
}
</script>

<template>
  <div
    v-for="{ paymentType, label } in choices"
    :key="paymentType"
    class="payment-type"
    :class="{'payment-type--selected': choice === paymentType}"
  >
    <div class="cmpr-radio-control">
      <CmprRadio
        :id="`payment_type_${paymentType}`"
        v-model="choice"
        class="payment-type__input"
        :class="[onlyChoiceSelected() ? 'payment-type__input--hidden' : '']"
        data-analytics-context="payment-step"
        :data-analytics-id="`${analyticsIdPrefix}-form-payment-type-${paymentType}-radiobutton`"
        data-analytics-inner-text="payment-type"
        name="paymentType"
        :value="paymentType"
      />
      <label
        class="payment-type-title cmpr-radio-control__label"
        :for="`payment_type_${paymentType}`"
      >
        {{ label }}
      </label>
    </div>
    <slot
      v-if="paymentType === choice"
      :name="paymentType"
    />
  </div>
</template>

<style scoped lang="scss">
.payment-type {
  background: var(--cmpr-color-white);
  border: var(--cmpr-border-width-20) solid var(--cmpr-color-neutral-30);
  border-radius: var(--cmpr-border-radius-20);
  display: flex;
  flex-direction: column;
  gap: var(--cmpr-space-60);
  padding: var(--cmpr-space-60);

  &-title {
    color: var(--cmpr-color-text);
    font-size: var(--cmpr-font-size-30);
    font-weight: var(--cmpr-font-weight-30);
    line-height: var(--cmpr-font-line-height-40);
  }

  &--selected {
    background: var(--cmpr-color-secondary-10);
    border: var(--cmpr-border-width-20) solid var(--cmpr-color-secondary-80);

    .payment-type-title {
      color: var(--cmpr-color-secondary-80);
    }
  }
}

.payment-type__input {
  &--hidden {
    display: none;
  }
}
</style>
